import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";


function ProjectTaskCategoryForm({ mode: modeProp }) {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = modeProp ?? (id ? "edit" : "add");

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);
  const org = userData?.organization;

  const fetchProjectTaskCategories = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-task-category/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          task_category_name: data.task_category_name || "",
          task_category_short_name: data.task_category_short_name || "",
          description: data.description || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project task Category data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && id) {
      fetchProjectTaskCategories();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    task_category_name: "",
    task_category_short_name: "",
    description: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.task_category_name) errors.task_category_name = "Project Task Category Name is required";
    if (formData.task_category_name.length > 50) errors.task_category_name = "Max 50 characters allowed";
    if (formData.task_category_short_name && formData.task_category_short_name.length > 20)
      errors.task_category_short_name = "Max 20 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-task-category/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Task Categories updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-task-category`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Task Categories added");
      }

      navigate("/project-task-categories");
    } catch (err) {
      if (err.response?.status === 422) {
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };




  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project Task Categories"}
        addMessage={"Project Task Categories"}
        homeLink={"/project-task-categories"}
        homeText={"Project Task Categories"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                <TextField
                  fullWidth
                  disabled={mode === "view"}
                  name="task_category_name"
                  label="Project Task Category Name *"
                  value={formData.task_category_name}
                  onChange={handleChange}
                  error={!!formErrors.task_category_name}
                  helperText={formErrors.task_category_name}
                />

                <TextField
                  fullWidth
                  name="task_category_short_name"
                  label="Project Task Category Short Name "
                  value={formData.task_category_short_name}
                  onChange={handleChange}
                  disabled={mode === "view"}
                  error={!!formErrors.task_category_short_name}
                  helperText={formErrors.task_category_short_name}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Description "
                  name="description"
                  disabled={mode === "view"}
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />

              </Grid>
              {mode !== "view" && (
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>
              )}

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTaskCategoryForm